import { Component, OnInit } from "@angular/core";

@Component({
  selector: "label-text",
  template:
    `
     <label>
         <ng-content></ng-content>
     </label>
  `,
  styleUrls: ["./label-text.component.css"]
})
export class LabelTextComponent implements OnInit {
  constructor() { }

  ngOnInit() { }
}
